var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsUnselected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.2,
    height: 13.033,
    viewBox: "0 0 11.2 13.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #35697e;\r\n        stroke: #35697e;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e11e24;\r\n        stroke: #e11e24;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    className: "cls-1",
    d: "M2.115,12.833A2.134,2.134,0,0,1,0,10.685V2.148A2.134,2.134,0,0,1,2.115,0H6.346A.353.353,0,0,1,6.4,0L11,4.73c0-.01,0-.02,0-.03a.262.262,0,0,1,0,.027v5.958a2.134,2.134,0,0,1-2.115,2.148ZM.846,2.148v8.536a1.281,1.281,0,0,0,1.269,1.289h6.77a1.281,1.281,0,0,0,1.269-1.289V5.156H8.039A2.135,2.135,0,0,1,5.923,3.008V.86H2.115A1.281,1.281,0,0,0,.846,2.148Zm5.923.859A1.281,1.281,0,0,0,8.039,4.3H9.555L6.769,1.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-2",
    d: "M0,5.586a.426.426,0,0,0,.423.43.426.426,0,0,0,.423-.43V.43A.426.426,0,0,0,.423,0,.426.426,0,0,0,0,.43Z",
    transform: "translate(2.962 3.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-2",
    d: "M.423,4.3A.426.426,0,0,1,0,3.867V.43A.426.426,0,0,1,.423,0,.426.426,0,0,1,.846.43V3.867A.426.426,0,0,1,.423,4.3Z",
    transform: "translate(5.077 5.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-2",
    d: "M.423,2.578A.426.426,0,0,1,0,2.148V.43A.426.426,0,0,1,.423,0,.426.426,0,0,1,.846.43V2.148A.426.426,0,0,1,.423,2.578Z",
    transform: "translate(7.192 7.19)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsUnselected);
export default __webpack_public_path__ + "static/media/reports-unselected.7fd1150ecec056e99b9b6c20f9d7d583.svg";
export { ForwardRef as ReactComponent };